import { CreateButton, TopToolbar } from "react-admin";

const ListActions = () => {
  return (
    <TopToolbar>
      <CreateButton />
    </TopToolbar>
  );
};

export default ListActions;
